<template>
  <div id="app">
    <Maintenance v-if="isMaintenanceMode" />
    <component v-else :is="layout" />
  </div>
</template>

<script>
import DefaultLayout from '@/layouts/Default/DefaultLayout'
import { USER_SELF } from '@/store/actions'
import Maintenance from '@/views/Maintenance'
import { IS_MAINTENANCE_MODE, showsMaintenancePage } from '@/maintenanceMode'
import PublicLayout from './layouts/Public/PublicLayout'

export default {
  components: {
    DefaultLayout,
    Maintenance,
    PublicLayout
  },
  beforeCreate: function () {
    if (IS_MAINTENANCE_MODE) {
      return
    }
    if (
      !this.$store.getters.isProfileLoaded &&
      localStorage.getItem('user-token')
    ) {
      return this.$store.dispatch(USER_SELF)
    }
  },
  data() {
    // this is needed to select the layout on initial page load
    const layout = this.$route.meta?.publicLayout
      ? 'PublicLayout'
      : 'DefaultLayout'
    return {
      layout
    }
  },
  computed: {
    isMaintenanceMode() {
      return showsMaintenancePage(this.$route)
    }
  },
  watch: {
    $route(to) {
      // this is needed for selecting the layout after a transition
      if (to.meta.publicLayout) {
        this.layout = 'PublicLayout'
      } else {
        this.layout = 'DefaultLayout'
      }
    }
  }
}
</script>
